export const CLEAR_PROPOSAL = 'PROPOSAL/CLEAR_PROPOSAL';
export const SEND_PROPOSAL = 'PROPOSAL/SEND_PROPOSAL';
export const SEND_PROPOSAL_SUCCESS = 'PROPOSAL/SEND_PROPOSAL_SUCCESS';
export const SEND_PROPOSAL_ERROR = 'PROPOSAL/SEND_PROPOSAL_ERROR';
